module.exports = __webpack_public_path__ + "static/media/3784.9bc953ff.jpg";